import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { ResponseError, ResponseSuccess, Response_ } from "./response";

const Client: AxiosInstance = axios.create({
  baseURL: `${process.env.VUE_APP_API}/`,
  timeout: 5000,
  withCredentials: true
});

Client.interceptors.request.use(
  (config: AxiosRequestConfig<any>) => {
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

Client.interceptors.response.use(
  (response: AxiosResponse<any, any>): Response_ => {
    return new ResponseSuccess(response);
  },
  (error: Error | AxiosError): Promise<Response_> => {
    if (axios.isAxiosError(error)) {
      return Promise.reject(new ResponseError(error));
    } else {
      return Promise.reject(error);
    }
  }
);

export default Client;
